document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        rootMargin: '100px',
    };
    function loadFlourishGraph(entry) {
        if (entry.isIntersecting) {
            const flourishEmbed = entry.target;
            if (!flourishEmbed.classList.contains('flourish-loaded')) {
                flourishEmbed.classList.add('flourish-loaded');

                // Create and embed the Flourish iframe manually
                const src = flourishEmbed.getAttribute('data-src');
                const iframe = document.createElement('iframe');
                iframe.src = `https://flo.uri.sh/${  src  }/embed`;
                iframe.setAttribute('scrolling', 'no');
                iframe.setAttribute('frameborder', '0');
                iframe.style.width = '100%';
                iframe.style.height = '500px';
                flourishEmbed.appendChild(iframe);
            }
        }
    }

    const observer = new IntersectionObserver(((entries) => {
        entries.forEach(loadFlourishGraph);
    }), observerOptions);

    document.querySelectorAll('.flourish-embed').forEach((el) => {
        observer.observe(el);
    });
});
